module.exports = __webpack_public_path__ + "static/media/venkat.6b96dc01.png";